/**
 * spritzung_resetAbschnittData
 * @param abschnitt
 * @returns {*}
 */
window.spritzung_resetAbschnittData = function(abschnitt) {
  abschnitt.find('input.abschnitt-bruehmenge').val('');
  abschnitt.find('input.abschnitt-bruehmenge-intern').val('');
  abschnitt.find('input[name="wasseraufwand"]').val('');
  abschnitt.find('.section-detail-mittel').remove();
};

/**
 * spritzung_recalculateSumme
 * berechnungen summenzeile
 * @param summeAlt
 * @param alleAbschnitteId
 * @param abschnitte
 * @param savedBruehe
 * @param isTeilspritzung
 * @returns {*&{bruehe: (*|number), mittel: {}}}
 */
window.spritzung_recalculateSumme = function(summeAlt, alleAbschnitteId, abschnitte, savedBruehe, isTeilspritzung = false) {
  let summeBrueheNeu;
  if (savedBruehe === true) {
    summeBrueheNeu = summeAlt.bruehe;
  } else {
    summeBrueheNeu = roundBruehe(alleAbschnitteId.map(id => abschnitte[id]).reduce((a, b) => b.bruehe + a, 0.0));
  }

  let sumFlaeche = [];
  if (isTeilspritzung) {
    for (const [, value] of Object.entries(abschnitte)) {
      for (const [key2] of Object.entries(value.mittel)) {
        if (typeof sumFlaeche[key2] === 'undefined') {
          sumFlaeche[key2] = value.flaeche;
        } else {
          sumFlaeche[key2] += value.flaeche;
        }
      }
    }
  }
  // verschiedene Mittel beachten
  let flaeche = alleAbschnitteId.map(id => abschnitte[id]).reduce((a, b) => b.flaeche + a, 0);
  const mittelNeu = {};
  summeAlt.alleMittelId.forEach(mittelId => {
        const mittelmengeNeu = roundMittelmenge(
            alleAbschnitteId.map(id => abschnitte[id]).map(abschnitt => abschnitt.mittel[mittelId]).reduce((summe, m) => {
              if (typeof (m) === 'undefined') {
                return summe + 0;
              } else {
                return summe + m.mittelmenge;
              }
            }, 0.0));
        // Rundungshölle. 0.144*10000/12 != 0.144/12*10000
        if (isTeilspritzung) {
          flaeche = sumFlaeche[mittelId];
        }
        const mittelmengeProHaNeu = roundMittelmengeProHa(mittelmengeNeu / flaeche * 10000);
        mittelNeu[mittelId] = {
          ...summeAlt.mittel[mittelId],
          mittelmenge: mittelmengeNeu,
          mittelmengeProHa: mittelmengeProHaNeu,
        };
      },
  );

  return {
    ...summeAlt,
    bruehe: summeBrueheNeu,
    mittel: mittelNeu,
  };
};